var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"text-center mx-auto"},[_vm._t("default",function(){return [_vm._v("Back")]})],2),_c('button',{staticClass:"btn",class:[this.btnClass],on:{"click":function($event){$event.preventDefault();return _vm.$emit('back-clicked')}}},[_c('i',{staticClass:"fas fa-2x fa-chevron-left"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }